const form = document.querySelector('.cs-form');
const submitButton = form ? form.querySelector('button[type="submit"], input[type="submit"]') : null;
let submitInFlight = false;

const PROXY_BASE = '/apps/merch-heroes-backend';

/* TODO: REMOVE AFTER PUBLIC LAUNCH (storefront password removed).
 * While the storefront is password-protected, Shopify blocks /apps/* App Proxy
 * requests. The theme renders an HMAC token in a meta tag; if present, we hit
 * the backend directly with the token in a header. After launch, delete this
 * branch and use App Proxy unconditionally. */
const STOREFRONT_TOKEN_META = document.querySelector('meta[name="mh-storefront-token"]');
const STOREFRONT_TOKEN = STOREFRONT_TOKEN_META ? STOREFRONT_TOKEN_META.getAttribute('content') : null;
const BACKEND_BASE = 'https://admin.merchheroes.com';

function endpoint(path) {
  if (STOREFRONT_TOKEN) {
    return {
      url: BACKEND_BASE + '/storefront' + path,
      headers: { 'X-MH-Storefront-Token': STOREFRONT_TOKEN },
    };
  }
  return { url: PROXY_BASE + path, headers: {} };
}

const pristine = new Pristine(
  form,
  {
    classTo: 'cs-form-field',
    errorClass: 'has-danger',
    successClass: 'has-success',
    errorTextParent: 'cs-form-field',
    errorTextTag: 'span',
    errorTextClass: 'cs-form-error',
  },
  true,
);

/* --- Custom validator for the username pattern --- */
const usernameInput = document.getElementById('username');
if (usernameInput) {
  pristine.addValidator(
    usernameInput,
    function (value) {
      if (!value) return true;
      return /^[a-z0-9_]+$/.test(value);
    },
    'Only lowercase letters, numbers, and underscores.',
    2,
    false,
  );

  /* --- Async uniqueness validator for the username (backend) --- */
  let usernameCheckTimer = null;
  let lastUsernameResult = null;
  let lastUsernameChecked = '';
  const usernameAvailable = document.getElementById('username-available');

  pristine.addValidator(
    usernameInput,
    function (value) {
      if (!value) return true;
      const normalized = value.trim().toLowerCase();
      if (normalized === lastUsernameChecked) return lastUsernameResult;
      return true; // optimistic until async check completes
    },
    'This username is already taken.',
    2,
    false,
  );

  usernameInput.addEventListener('input', function () {
    const value = usernameInput.value.trim();

    if (usernameCheckTimer) clearTimeout(usernameCheckTimer);

    if (!value) {
      lastUsernameChecked = '';
      lastUsernameResult = null;
      if (usernameAvailable) usernameAvailable.style.display = 'none';
      return;
    }

    /* Skip the backend round-trip when format is wrong — pristine will already block. */
    if (!/^[a-z0-9_]+$/.test(value)) {
      lastUsernameChecked = value.toLowerCase();
      lastUsernameResult = null;
      if (usernameAvailable) usernameAvailable.style.display = 'none';
      return;
    }

    usernameCheckTimer = setTimeout(function () {
      const ep = endpoint('/validate/username?username=' + encodeURIComponent(value));
      fetch(ep.url, {
        headers: Object.assign({ Accept: 'application/json' }, ep.headers),
      })
        .then(function (res) {
          if (res.status !== 200) return null;
          return res.json();
        })
        .then(function (body) {
          lastUsernameChecked = value.toLowerCase();
          /* Backend reachable: trust the answer. Backend unreachable (null body): treat as
             available so we don't block the user on transient errors. */
          lastUsernameResult = body ? body.valid === true : true;

          if (usernameInput.value.trim() === value) {
            pristine.validate(usernameInput);
            if (usernameAvailable) {
              usernameAvailable.style.display = lastUsernameResult ? '' : 'none';
            }
          }
        })
        .catch(function () {
          /* Network error – treat as available so we don't block the user */
          lastUsernameChecked = value.toLowerCase();
          lastUsernameResult = true;
          if (usernameAvailable) usernameAvailable.style.display = '';
        });
    }, 400);
  });
}

/* --- URL validators for TikTok and YouTube fields --- */
const urlPattern = /^https?:\/\/.+\..+/;

const tiktokInput = document.getElementById('social-handle-4');
if (tiktokInput) {
  pristine.addValidator(
    tiktokInput,
    function (value) {
      if (!value) return true;
      return urlPattern.test(value.trim());
    },
    'Please enter a valid URL (e.g. https://www.tiktok.com/@handle)',
    2,
    false,
  );
}

const youtubeInput = document.getElementById('social-handle-5');
if (youtubeInput) {
  pristine.addValidator(
    youtubeInput,
    function (value) {
      if (!value) return true;
      return urlPattern.test(value.trim());
    },
    'Please enter a valid URL (e.g. https://www.youtube.com/@channel)',
    2,
    false,
  );
}

const facebookInput = document.getElementById('facebook');
if (facebookInput) {
  pristine.addValidator(
    facebookInput,
    function (value) {
      if (!value) return true;
      return urlPattern.test(value.trim());
    },
    'Please enter a valid URL (e.g. https://www.facebook.com/name)',
    2,
    false,
  );
}

/* --- Async uniqueness validator for the store name (collection title) --- */
const storeNameInput = document.getElementById('store-name');
if (storeNameInput) {
  let nameCheckTimer = null;
  let lastNameResult = null;
  let lastNameChecked = '';
  const storeNameAvailable = document.getElementById('store-name-available');

  function handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  pristine.addValidator(
    storeNameInput,
    function (value) {
      if (!value) return true;
      const normalized = value.trim().toLowerCase();
      if (normalized === lastNameChecked) return lastNameResult;
      return true; // optimistic until async check completes
    },
    'This store name is already taken.',
    2,
    false,
  );

  storeNameInput.addEventListener('input', function () {
    const normalized = storeNameInput.value.trim().toLowerCase();

    if (nameCheckTimer) clearTimeout(nameCheckTimer);

    if (!normalized) {
      lastNameChecked = '';
      lastNameResult = null;
      if (storeNameAvailable) storeNameAvailable.style.display = 'none';
      return;
    }

    nameCheckTimer = setTimeout(function () {
      /* Backend round-trip — checks both approved stores and pending/approved applications.
         Replaces the previous Shopify `/collections/<handle>.json` check, which is unreachable
         while the storefront is password-protected. */
      const ep = endpoint('/validate/store-name?store_name=' + encodeURIComponent(normalized));
      fetch(ep.url, {
        headers: Object.assign({ Accept: 'application/json' }, ep.headers),
      })
        .then(function (res) {
          if (res.status !== 200) return null;
          return res.json();
        })
        .then(function (body) {
          lastNameChecked = normalized;
          // Backend reachable: trust the answer. Backend unreachable (null body): treat as
          // available so we don't block the user on transient errors.
          lastNameResult = body ? body.valid === true : true;

          if (storeNameInput.value.trim().toLowerCase() === normalized) {
            pristine.validate(storeNameInput);
            if (storeNameAvailable) {
              storeNameAvailable.style.display = lastNameResult ? '' : 'none';
            }
          }
        })
        .catch(function () {
          // Network error – treat as available so we don't block the user
          lastNameChecked = normalized;
          lastNameResult = true;
          if (storeNameAvailable) storeNameAvailable.style.display = '';
        });

      /* TODO: previous Shopify-side check kept here for easy revert.
      const handle = handleize(normalized);
      fetch('/collections/' + encodeURIComponent(handle) + '.json')
        .then(function (response) {
          if (response.status !== 200) {
            lastNameChecked = normalized;
            lastNameResult = true;
          } else {
            return response.json().then(function (data) {
              lastNameChecked = normalized;
              const existingTitle = (data.collection && data.collection.title) || '';
              lastNameResult = existingTitle.toLowerCase() !== normalized;
            });
          }
        })
        .then(function () {
          if (storeNameInput.value.trim().toLowerCase() === normalized) {
            pristine.validate(storeNameInput);
            if (storeNameAvailable) {
              storeNameAvailable.style.display = lastNameResult ? '' : 'none';
            }
          }
        })
        .catch(function () {
          lastNameChecked = normalized;
          lastNameResult = true;
          if (storeNameAvailable) storeNameAvailable.style.display = '';
        });
      */
    }, 400);
  });
}

/* --- Async uniqueness validator for the store URL (collection handle) --- */
const storeUrlInput = document.getElementById('store-slug');
if (storeUrlInput) {
  let slugCheckTimer = null;
  let lastSlugResult = null;
  let lastSlugChecked = '';
  const storeUrlAvailable = document.getElementById('store-url-available');

  pristine.addValidator(
    storeUrlInput,
    function (value) {
      if (!value) return true;
      const slug = value.trim().toLowerCase();
      if (slug === lastSlugChecked) return lastSlugResult;
      return true; // optimistic until async check completes
    },
    'This store URL is already taken.',
    2,
    false,
  );

  storeUrlInput.addEventListener('input', function () {
    const slug = storeUrlInput.value.trim().toLowerCase();

    if (slugCheckTimer) clearTimeout(slugCheckTimer);

    if (!slug) {
      lastSlugChecked = '';
      lastSlugResult = null;
      if (storeUrlAvailable) storeUrlAvailable.style.display = 'none';
      return;
    }

    slugCheckTimer = setTimeout(function () {
      /* Backend is the source of truth (covers pending applications + approved stores).
         The Shopify /collections/<slug> HEAD fallback is currently disabled — re-enable
         once we trust storefront-side validation again. */
      const ep = endpoint('/validate/store-slug?slug=' + encodeURIComponent(slug));
      fetch(ep.url, {
        headers: Object.assign({ Accept: 'application/json' }, ep.headers),
      })
        .then(function (res) {
          if (res.status !== 200) return null;
          return res.json();
        })
        .then(function (body) {
          if (body && body.valid === false) {
            lastSlugChecked = slug;
            lastSlugResult = false;
            return;
          }
          // Backend says available OR unreachable: trust it (no Shopify fallback for now).
          lastSlugChecked = slug;
          lastSlugResult = true;
          /* TODO: re-enable Shopify collection HEAD fallback.
          return fetch('/collections/' + encodeURIComponent(slug), { method: 'HEAD' })
            .then(function (response) {
              lastSlugChecked = slug;
              lastSlugResult = response.status !== 200;
            });
          */
        })
        .then(function () {
          /* Re-run Pristine on this field so the result is picked up */
          if (storeUrlInput.value.trim().toLowerCase() === slug) {
            pristine.validate(storeUrlInput);
            if (storeUrlAvailable) {
              storeUrlAvailable.style.display = lastSlugResult ? '' : 'none';
            }
          }
        })
        .catch(function () {
          /* Network error – treat as available so we don't block the user */
          lastSlugChecked = slug;
          lastSlugResult = true;
          if (storeUrlAvailable) storeUrlAvailable.style.display = '';
        });
    }, 400);
  });
}

/* --- Signature (hidden input – not tracked by Pristine) --- */
const signatureInput = document.getElementById('signature');
const signatureWrapper = signatureInput ? signatureInput.closest('.cs-form-field') : null;

function clearSignatureError() {
  if (!signatureWrapper) return;
  const existing = signatureWrapper.querySelector('.pristine-error.cs-form-error');
  if (existing) existing.remove();
  signatureWrapper.classList.remove('has-danger');
}

function showSignatureError(msg) {
  if (!signatureWrapper) return;
  clearSignatureError();
  signatureWrapper.classList.add('has-danger');
  const span = document.createElement('span');
  span.className = 'pristine-error cs-form-error';
  span.textContent = msg;
  signatureWrapper.appendChild(span);
}

if (signatureInput) {
  const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
  Object.defineProperty(signatureInput, 'value', {
    get: function () {
      return descriptor.get.call(this);
    },
    set: function (v) {
      descriptor.set.call(this, v);
      if (v && v.trim()) {
        clearSignatureError();
      }
    },
    configurable: true,
  });
}

/* --- Profile picture (hidden input – not tracked by Pristine) --- */
const croppedInput = document.getElementById('profile-photo');
const uploadWrapper = document.getElementById('upload-wrapper');

function clearProfileError() {
  if (!uploadWrapper) return;
  const existing = uploadWrapper.querySelector('.pristine-error.cs-form-error');
  if (existing) existing.remove();
  uploadWrapper.classList.remove('has-danger');
}

function showProfileError(msg) {
  if (!uploadWrapper) return;
  clearProfileError();
  uploadWrapper.classList.add('has-danger');
  const span = document.createElement('span');
  span.className = 'pristine-error cs-form-error';
  span.textContent = msg;
  uploadWrapper.appendChild(span);
}

/* Clear profile error when a photo is cropped.
   Property descriptor intercept catches programmatic .value = … sets
   that MutationObserver and change/input events miss. */
if (croppedInput) {
  const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
  Object.defineProperty(croppedInput, 'value', {
    get: function () {
      return descriptor.get.call(this);
    },
    set: function (v) {
      descriptor.set.call(this, v);
      if (v && v.trim()) {
        clearProfileError();
      }
    },
    configurable: true,
  });
}

/* --- Submit handler --- */
form.addEventListener('submit', async (e) => {
  if (submitInFlight) {
    e.preventDefault();
    return;
  }

  let isValid = pristine.validate();

  /* Validate profile picture manually */
  const hasPhoto = window.__croppedProfileFile instanceof File;
  if (!hasPhoto) {
    isValid = false;
    showProfileError('Profile picture is required.');
  } else {
    clearProfileError();
  }

  /* Validate signature manually */
  const hasSignature = signatureInput && signatureInput.value.trim();
  if (!hasSignature) {
    isValid = false;
    showSignatureError('Signature is required.');
  } else {
    clearSignatureError();
  }

  if (!isValid) {
    e.preventDefault();
    submitInFlight = false;
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-busy');
    }
    const firstError = form.querySelector('.has-danger');
    if (firstError) {
      firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  } else {
    e.preventDefault();
    submitInFlight = true;
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
    }

    const formData = new FormData(form);

    /* Replace the hidden-input flag with the actual cropped File */
    formData.delete('profile-photo');
    if (window.__croppedProfileFile) {
      formData.append('profile-photo', window.__croppedProfileFile, 'profile-photo.png');
    }

    try {
      /* POST through Shopify App Proxy (signature verified by backend middleware)
         OR, while the storefront has a password, directly via the storefront-token
         endpoint (TODO: remove direct branch after public launch). */
      const ep = endpoint('/store-applications');
      const response = await fetch(ep.url, {
        method: 'POST',
        body: formData,
        headers: ep.headers,
        // Do NOT set Content-Type header — the browser sets it
        // automatically with the correct multipart boundary.
      });
      const result = await response.json();

      if (response.ok) {
        // Application submitted successfully

        // Let's just show a message if on the password page
        const currentUrl = window.location.href;

        if (currentUrl.includes('password')) {
          let message = document.createElement('div');
          message.innerHTML =
            '<h2>Thanks for signing up!</h2>' +
            '<p>Thank you for signing up with MerchHeroes.com. We have received your application and it will now be put into the approval process and we\'ll get back to you within 72 hours. If you have any questions, please email <a href="mailto:help@prowrestlingtees.com">help@merchheroes.com</a>.</p>';

          form.parentNode.replaceChild(message, form);
          message.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.location.href = '/pages/confirmation';
        }
      } else {
        // Validation error — show the error message
        // result.field contains the field name that caused the error
        //console.log('result.field', result.field);
        // const errorField = document.querySelector(`[name="${result.field}"]`);

        // if (errorField) {
        //   errorField.classList.add('is-invalid');
        // }

        document.getElementById('server-errors').innerHTML = result.error;
        document.getElementById('server-errors').style.display = 'block';
        submitInFlight = false;
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
        }
      }
    } catch (err) {
      alert('Something went wrong. Please try again.');
      submitInFlight = false;
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      }
    }
  }
});
